import axios from 'axios'
import Auth from '@/services/auth'
import {
  API_BASE,
  apiErrorHandler,
  ApiFilter,
  isDefinedAndNotNull,
  isNotEmpty,
} from '@/services/api'
import {
  objectToCamelCase,
  objectToSnakeCase,
  formatDateShort,
  formatNumberAsUSD,
} from '@/services/utils'
const NOMINEES_ENDPOINT = `${API_BASE}nominees/`

const NomineesApi = {
  getRequestOptions() {
    return {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
  },

  // Helper to create a new course code
  async addCourseCode(courseNumber, code) {
    try {
      const response = await axios.post(
        NOMINEES_ENDPOINT + 'add-course-code',
        { course_number: courseNumber, code: code },
        this.getRequestOptions(),
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return false
  },

  // Helper to retrieve nomination data
  async getNominationData(id) {
    try {
      const response = await axios.post(
        NOMINEES_ENDPOINT + 'nomination-data',
        { nomination_id: id },
        this.getRequestOptions(),
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return false
  },

  // Helper to create a new stipend request
  async createOrGetStipendRequest(stipendRequest = null) {
    try {
      const response = await axios.post(
        NOMINEES_ENDPOINT + 'create-or-get-stipend-request',
        { stipend_request: stipendRequest },
        this.getRequestOptions(),
      )

      if(response && response.data && response.data.success)
        return objectToCamelCase(response.data.stipend_request)
    } catch (error) {
      console.error(error)
    }

    return null
  },

  async saveStipendRequest(stipendRequest) {
    try {
      const response = await axios.post(
        NOMINEES_ENDPOINT + 'save-stipend-request',
        { stipend_request: stipendRequest },
        this.getRequestOptions(),
      )

      return response.data.success
    } catch (error) {
      console.error(error)
    }

    return false
  },

  async submitStipendRequest(stipendRequestId) {
    try {
      const response = await axios.post(
        NOMINEES_ENDPOINT + 'submit-stipend-request',
        { stipend_request_id: stipendRequestId },
        this.getRequestOptions(),
      )

      return true
    } catch (error) {
      console.error(error)
    }

    return false
  },
}

export default NomineesApi
